import { render } from "./CustomColor.vue?vue&type=template&id=60dabc90"
import script from "./CustomColor.vue?vue&type=script&lang=ts"
export * from "./CustomColor.vue?vue&type=script&lang=ts"
script.render = render

export default script